import { css } from "styled-components";

import {getTheme} from "./themeUtils";

export const scrollbarTrack = css`
::-webkit-scrollbar {
    width: ${getTheme("space.1")};
  }
  
  ::-webkit-scrollbar-track {
    background: ${getTheme("colors.lightGrey")}; 
  }
  
  ::-webkit-scrollbar-thumb {
    background: ${getTheme("colors.border")};
  }
  
  scrollbar-color: ${getTheme("colors.border")} ${getTheme("colors.lightGrey")}; 
  scrollbar-width: thin;
`;